<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="dialog-icon" fontIcon="lock_clock"></mat-icon>
  <span>{{ 'platform.session-expired.title' | translate }}</span>
</h2>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-message">{{ 'platform.session-expired.body' | translate }}</p>
</div>

<div mat-dialog-actions align="center" class="dialog-actions">
  <button mat-raised-button class="btn btn-sm btn-primary text-white" (click)="exit()">
    {{ 'platform.session-expired.action' | translate }}
  </button>
</div>
